// sprak.js — Språkfil for Topp 100
// ─────────────────────────────────────────────────────────────────────────────
// Bokmål (nb) er HOVUDSPRÅK og standard. Nynorsk (nn) ligg klar.
// Legg til nye nøklar i BEGGE objekta. Manglar ein nøkkel i nn, fell han
// automatisk tilbake til nb (sjå t() i App.jsx).
//
// Interpolasjon: bruk {namn} i teksten og kall t("nøkkel", { namn: "x" }).
// ─────────────────────────────────────────────────────────────────────────────

export const nb = {
  // ── Fanar / navigasjon ──────────────────────────────────────────────────
  "fane.kart": "Kart",
  "fane.toppar": "Topper",
  "fane.logg": "Logg",
  "fane.badges": "Troféer",
  "fane.innst": "Innstillinger",

  // ── Merkevare ───────────────────────────────────────────────────────────
  "merke.tittel": "TINDRE",
  "merke.undertittel": "Fjellregistrering",
  "merke.namn": "Tindre",
  "merke.kommune": "Fjellregistrering for Bergen kommune",

  // ── Filter (kart) ───────────────────────────────────────────────────────
  "filter.tittel": "🔍 Filter",
  "filter.nullstill": "Nullstill",
  "filter.fylke": "Fylke",
  "filter.kommune": "Kommune",
  "filter.vis": "Vis",
  "filter.minHogde": "Minste høyde",
  "filter.alleToppar": "Alle topper",
  "filter.berreUbesokte": "Bare ubesøkte",
  "filter.berreBesokte": "Bare besøkte",

  // ── Topp-panel / registrering ───────────────────────────────────────────
  "topp.aktiverGps": "📍 Aktiver GPS for å se avstand",
  "topp.henterPos": "Finner nøyaktig posisjon…",
  "topp.gpsNoeyaktigheit": "GPS-nøyaktighet ±{n} m",
  "topp.forLangtBort": "Du er {n} m unna. Gå litt nærmere og prøv igjen.",
  "topp.tidlegareBesokt": "✓ Tidligere besøkt — gjentagende besøk gir nye poeng!",
  "topp.gaTilKart": "Gå til kartet, trykk på en topp og registrer!",
  "topp.sisteTurar": "Siste turer",
  "topp.ingenTurar": "Ingen turer registrert ennå",
  "topp.ingenBilete": "Ingen bilder ennå — bli den første!",
  "brukar.toppar": "topper",
  "brukar.turar": "turer",
  "brukar.feil": "Kunne ikke laste profilen",
  "folg.maksNaadd": "Du kan følge maks {n} personer. Slutt å følge noen for å følge flere.",
  "folg.feil": "Kunne ikke oppdatere følging. Prøv igjen.",
  "topp.visKart": "Vis på kartet",

  // ── Logg ────────────────────────────────────────────────────────────────
  "logg.unikeToppar": "Unike topper",
  "logg.totaleTurar": "Totale turer",
  "logg.poeng": "Poeng",
  "logg.ingenBesok": "Ingen registrerte besøk ennå.",
  "logg.idag": "← i dag",
  "logg.slettBilde": "Slett bildet?",

  // ── Trofé / fanfare ─────────────────────────────────────────────────────
  "trofe.nytt": "🏆 Nytt trofé!",
  "trofe.hemmelegAvslort": "✨ Hemmelig trofé avslørt!",
  "trofe.tittel": "Troféer",
  "trofe.hemmeleg": "✨ Hemmelig",
  "trofe.lastOpp": "Låst opp!",
  "fanfare.fullfort": "FULLFØRT!",
  "fanfare.alleToppar": "Du har besteget alle toppene!",
  "fanfare.toppPoeng": "Topp-poeng",
  "fanfare.bonus": "Bonus 🎉",

  // ── Statistikk ──────────────────────────────────────────────────────────
  "stat.tittel": "📊 Statistikk",
  "stat.forsteTur": "Første tur",
  "stat.sisteTur": "Siste tur",
  "stat.rekorddag": "Rekorddag",
  "stat.idag": "I dag",
  "stat.igar": "I går",
  "stat.dagarSidan": "{n} dager siden",
  "stat.toppar": "{n} topper",
  "stat.turar": "Turer",
  "stat.hogdemeter": "Høydemeter",
  "felles.poengSmaa": "poeng",

  // ── Vêr ─────────────────────────────────────────────────────────────────
  "ver.lastar": "🌤 Laster vær…",
  "ver.feil": "Kunne ikke hente vær",
  "ver.imorgon": "i morgen",
  "ver.klart": "Klart",
  "ver.lettskya": "Lettskyet",
  "ver.overskya": "Overskyet",
  "ver.take": "Tåke",
  "ver.yr": "Yr",
  "ver.regn": "Regn",
  "ver.sno": "Snø",
  "ver.regnbyer": "Regnbyger",
  "ver.snobyer": "Snøbyger",
  "ver.torden": "Tordenvær",
  "ver.perPunktAv": "Vær per punkt er skrudd av i innstillinger",

  // ── Kart ────────────────────────────────────────────────────────────────
  "kart.lastar": "Laster kart…",
  "kart.resetNord": "Reset nord",
  "kart.sokStadnamn": "Søk på stedsnavn…",
  "kart.sokjer": "Søker…",
  "kart.toppbilde": "Toppbilde",

  // ── Admin (rediger topp) ────────────────────────────────────────────────
  "admin.rediger": "✏️ Admin — Rediger topp",
  "admin.namn": "Navn",
  "admin.hogde": "Høyde (moh.)",
  "admin.lister": "Lister",
  "admin.trykkFlytt": "← Trykk på kartet for å flytte",
  "admin.modus": "Admin-modus ✏️",
  "admin.modusSkildring": "Rediger og flytt topper direkte i kartet",
  "admin.lastNed": "⬇ Last ned peaks.js",
  "admin.nullstill": "Nullstill endringer",
  "admin.nullstillSporsmal": "Nullstill admin-endringer?",
  "admin.endra": "✏ Endret — autolagret",

  // ── Innlogging / tilgang ────────────────────────────────────────────────
  "inn.tittel": "Tindre",
  "inn.skrivKode": "Skriv inn tilgangskode",
  "inn.kodePrompt": "Skriv inn tilgangskoden din",
  "inn.kodeInfo": "Du har mottatt en kode på e-post. Skriv den inn for å komme inn.",
  "inn.kodePlassholdar": "F.eks. FJELL-1234",
  "inn.harIkkjeKode": "Har du ikke kode? Be om tilgang",
  "inn.soknadSendt": "Søknad sendt!",
  "inn.soknadInfo": "Du vil motta en tilgangskode på e-post innen kort tid.",
  "inn.tilbakeKode": "← Tilbake til kode-innlogging",
  "inn.beOmTilgang": "Be om tilgang",
  "inn.epostInfo": "Skriv inn e-postadressen din. Du vil motta en kode på e-post.",
  "inn.epostPlassholdar": "din@epost.no",

  // ── Innstillingar ───────────────────────────────────────────────────────
  "innst.tittel": "Innstillinger",
  "innst.fullskjerm": "Fullskjerm kart",
  "innst.fullskjermAv": "Slå av for å gå tilbake til normal visning",
  "innst.fullskjermSkildring": "Hele skjermen til kart — flytende kontroller",
  "innst.morktTema": "Mørkt tema",
  "innst.morktSkildring": "Bytt mellom mørkt og lyst utseende",
  "innst.testmodus": "Testmodus",
  "innst.testSkildring": "Registrer topper uten å være på stedet",
  "innst.testFanfare": "🏆 Test fanfare",
  "innst.verPunkt": "Vær ved kartpunkt",
  "innst.verPunktSkildring": "Vis værvarsel når du trykker på kartet",
  "innst.filterLogg": "Filter i logg",
  "innst.filterLoggSkildring": "Filtrer loggen på periode, liste og bilde",
  "innst.visHogde": "Vis høyde (moh)",
  "innst.visHogdeSkildring": "Vis din høyde over havet på kartet",
  "innst.visMalestokk": "Vis målestokk",
  "innst.visMalestokkSkildring": "Vis avstandsskala på kartet",
  "innst.skjulUtanBilde": "Skjul besøk uten bilde",
  "innst.skjulUtanBildeSkildring": "Vis kun turer med bilde på topp-profilen",
  "innst.kompakt": "Kompakt visning",
  "innst.kompaktSkildring": "Skjul progress-boksene, bare ikon i nav",
  "innst.listeLayout": "Listelayout",
  "innst.listeLayoutNytt": "Nytt (med bilde)",
  "innst.listeLayoutGammalt": "Klassisk",
  "innst.loggKort": "Loggkort",
  "innst.loggKortNytt": "Nytt",
  "innst.loggKortGammalt": "Klassisk",
  "innst.regStil": "Registreringsstil",
  "innst.regStilSkriv": "Skriv inn",
  "innst.regStilSkyv": "Skyv for å registrere",
  "innst.fargetema": "Fargetema",
  "innst.fargetemaSkildring": "Velg aksentfarge for appen",
  "innst.bursdag": "🎂 Bursdag",
  "innst.bursdagSkildring": "Kanskje skjer det noe spesielt på dagen din…",
  "innst.kartdata": "Kartdata",
  "innst.landingsside": "Tindre — Landingsside",
  "innst.landingsSkildring": "Info om appen",
  "innst.loggUt": "Logg ut",
  "innst.loggUtSporsmal": "Logg ut? Du trenger koden din for å komme inn igjen.",
  "innst.nullstillData": "Nullstill all data",
  "innst.nullstillDataSporsmal": "Nullstill ALL registreringsdata? Dette kan ikke angres.",
  "innst.sprak": "Språk",
  "innst.sprakSkildring": "Velg språk for appen",

  // ── Språk-namn ──────────────────────────────────────────────────────────
  "sprak.nb": "Bokmål",
  "sprak.nn": "Nynorsk",

  // ── Fargetema-namn ──────────────────────────────────────────────────────
  "tema.oransje": "Oransje",
  "tema.bla": "Kongeblå",

  // ── Logg-filter ─────────────────────────────────────────────────────────
  "loggf.alle": "Alle",
  "loggf.veke": "Denne uka",
  "loggf.mnd": "Denne måneden",
  "loggf.aar": "I år",
  "loggf.alleLister": "Alle lister",
  "loggf.medBilde": "Med bilde",
  "loggf.utanBilde": "Uten bilde",

  // ── Trofé-kategoriar ────────────────────────────────────────────────────
  "kat.topper": "Topper & Lister",
  "kat.lister": "Listemestere",
  "kat.streak": "Streaks",
  "kat.tid": "Tid & Sesong",
  "kat.spesial": "Spesial ⭐",

  // ── Lagring ─────────────────────────────────────────────────────────────
  "lagring.full": "⚠ Lagringen er full — siste endring kunne ikke lagres. Slett noen bilder i loggen.",

  // ── Diverse ─────────────────────────────────────────────────────────────
  "map.avsluttFullskjerm": "Avslutt fullskjerm",
  "map.fullskjerm": "Fullskjerm",
  "ver.hentarHogde": "Henter høyde…",
  "ver.ukjendHogde": "Ukjent høyde",
  "ver.dettePunktet": "dette punktet",
  "inn.gaaTilApp": "Gå til appen →",
  "inn.sjekkar": "⟳ Sjekker…",
  "inn.sender": "⟳ Sender…",
  "inn.sendForespurnad": "Send forespørsel →",
  "inn.epostEmne": "Ny Tindre-forespørsel om tilgang",
  "inn.ventS": "🔒 Vent {s}s",
  "stat.aktiveDagar": "Aktive dager",
  "stat.hogasteTopp": "Høyeste topp",
  "stat.totalHogdemeter": "Total høydemeter",
  "stat.dagar": "{n} dager",
  "innst.testPaa": "🧪 Testmodus PÅ — du kan registrere uten GPS",
  "innst.testAv": "Testmodus AV",
  "kat.hemmelege": "Hemmelige 🔒",

  // ── Innlogging (Supabase) ───────────────────────────────────────────────
  "auth.loggInnTittel": "Logg inn",
  "auth.registrerTittel": "Lag konto",
  "auth.epost": "E-post",
  "auth.passord": "Passord",
  "auth.visingsnamn": "Visingsnamn",
  "auth.epostPlassh": "din@epost.no",
  "auth.passordPlassh": "Minst 6 teikn",
  "auth.namnPlassh": "Det andre ser deg som",
  "auth.loggInnKnapp": "Logg inn",
  "auth.registrerKnapp": "Lag konto",
  "auth.loggerInn": "⟳ Loggar inn…",
  "auth.registrerer": "⟳ Lagar konto…",
  "auth.byttTilRegistrer": "Ny her? Lag konto",
  "auth.byttTilInnlogging": "Har du konto? Logg inn",
  "auth.feilInnlogging": "Feil e-post eller passord",
  "auth.feilEpostFinst": "E-posten er allereie registrert",
  "auth.feilPassordKort": "Passordet må vere minst 6 teikn",
  "auth.invkodePlassh": "Invitasjonskode",
  "auth.feilInvkode": "Ugyldig invitasjonskode",
  "auth.feilNamnManglar": "Skriv eit visingsnamn",
  "auth.feilEpostUgyldig": "Skriv ei gyldig e-postadresse",
  "auth.feilGenerell": "Noko gjekk gale. Prøv igjen.",
  "auth.feilBackend": "Får ikkje kontakt med tenaren. Prøv igjen seinare.",
  "auth.loggUt": "Logg ut",
  "auth.loggUtSporsmal": "Logg ut?",

  // ── Utforskande modus (utan konto) ──────────────────────────────────────
  "utforsk.loggInn": "Logg inn",
  "utforsk.registrerKrev": "Logg inn for å registrere",
  "utforsk.loggKrev": "Logg inn for å sjå loggen din og samle topper.",
  "utforsk.trofeKrev": "Logg inn for å låse opp og samle troféer.",
  "utforsk.loggInnKnapp": "Logg inn / lag konto",

  // ── Bilde ────────────────────────────────────────────────────────────────
  "bilde.berreBilete": "Bare bilder er tillatt (JPG, PNG, HEIC).",
  "bilde.feilLes": "Klarte ikke å lese bildet. Prøv et annet.",
  "bilde.forStort": "Bildet er for stort. Velg et mindre.",
  "bilde.tittel": "Legg til bilde",
  "bilde.dokumenter": "{namn} — dokumenter toppbesøket",
  "bilde.taBilde": "Ta bilde",
  "bilde.velBibliotek": "Velg fra bibliotek",

  // ── Profil ──────────────────────────────────────────────────────────────
  "test.kodePrompt": "Skriv testkode:",
  "test.opna": "Testmodus låst opp 🧪",
  "test.laas": "Lås testmodus",
  "profil.tittel": "Profil",
  "profil.rediger": "Rediger",
  "profil.namn": "Visningsnavn",
  "profil.bosted": "Bosted",
  "profil.bostedPlassh": "F.eks. Bergen",
  "profil.bursdag": "Bursdag",
  "profil.dag": "Dag",
  "profil.maaned": "Måned",
  "profil.epost": "E-post",
  "profil.synlegAndre": "Synlig for andre seinare",
  "profil.berreDu": "Berre du ser dette",
  "profil.fyllUt": "Trykk for å fylle ut profilen",
  "profil.lagra": "Lagre",
  "profil.lagrar": "Lagrar…",
  "profil.feilNamn": "Du må ha eit visningsnavn",
  "profil.feilLagra": "Klarte ikkje lagre. Sjekk nettet og prøv igjen.",

  // ── Dagsturhytter + kart-filter ─────────────────────────────────────────
  "hytte.merkelapp": "Dagsturhytte",
  "hytte.framme": "Du er ved hytta!",
  "topp.framme": "Du er på toppen!",
  "innst.punktFilter": "Vis på kartet",
  "innst.punktFilterSkildring": "Velg om kartet viser toppar, hytter eller begge.",
  "punkt.begge": "Begge",
  "punkt.toppar": "Topper",
  "punkt.hytter": "Hytter",

  // ── Gløymt passord (kode-basert recovery) ───────────────────────────────
  "auth.glemtLenke": "Glemt passordet?",
  "auth.glemtTittel": "Tilbakestill passord",
  "auth.glemtEpostInfo": "Skriv e-posten din, så sender vi en kode du kan bruke til å velge nytt passord.",
  "auth.sendKode": "Send kode",
  "auth.sender": "⟳ Sender…",
  "auth.kodeSendtTittel": "Sjekk e-posten din",
  "auth.kodeInfo": "Har du en konto hos oss, har vi sendt en kode til e-posten. Skriv den inn og velg et nytt passord.",
  "auth.kode": "Kode",
  "auth.kodePlassh": "Kode fra e-posten",
  "auth.nyttPassord": "Nytt passord",
  "auth.settPassord": "Sett nytt passord",
  "auth.oppdaterer": "⟳ Oppdaterer…",
  "auth.feilKode": "Feil eller utløpt kode",
  "auth.tilbakeInnlogging": "← Tilbake til innlogging",
  "auth.passordOppdatert": "Passordet er oppdatert.",

  // ── Troféar (badges) ────────────────────────────────────────────────────
  "badge.b10.namn": "Klatrer",
  "badge.b10.skildring": "Besøkt 10 unike topper",
  "badge.b25.namn": "Fjellvenn",
  "badge.b25.skildring": "Besøkt 25 unike topper",
  "badge.b50.namn": "Toppjeger",
  "badge.b50.skildring": "Besøkt 50 unike topper",
  "badge.ball.namn": "Bergensmester",
  "badge.ball.skildring": "Alle topper i Bergen fullført",
  "badge.t10.namn": "Topp 10",
  "badge.t10.skildring": "Fullført Topp 10-listen",
  "badge.t20.namn": "Topp 20",
  "badge.t20.skildring": "Fullført Topp 20-listen",
  "badge.t50.namn": "Topp 50",
  "badge.t50.skildring": "Fullført Topp 50-listen",
  "badge.t100.namn": "Topp 100",
  "badge.t100.skildring": "Fullført Topp 100-listen",
  "badge.dobbel.namn": "Dobbelen",
  "badge.dobbel.skildring": "2 topper samme dag",
  "badge.trippel.namn": "Trippelen",
  "badge.trippel.skildring": "3 topper samme dag",
  "badge.femmar.namn": "Femmeren",
  "badge.femmar.skildring": "5 topper samme dag",
  "badge.tidleg.namn": "Morgenfugl",
  "badge.tidleg.skildring": "Registrert en topp før kl. 07:00",
  "badge.natt.namn": "Nattugla",
  "badge.natt.skildring": "Registrert en topp etter kl. 21:00",
  "badge.vinter.namn": "Vinterfjell",
  "badge.vinter.skildring": "Topp i desember",
  "badge.nyttaar.namn": "Nyttårsklatrer",
  "badge.nyttaar.skildring": "Topp 1. januar",
  "badge.syttande.namn": "17. mai-klatrer",
  "badge.syttande.skildring": "Registrert en topp på nasjonaldagen",
  "badge.baal.namn": "Jonsokbål",
  "badge.baal.skildring": "Besøkt Gullfjellet etter kl. 18:00 på sankthans (23. juni)",
  "badge.sju.namn": "7-fjellsturen",
  "badge.sju.skildring": "Alle 7 fjell i rett rekkefølge samme dag",
  "badge.h1.namn": "Soloppgang",
  "badge.h1.skildring": "Registrert en topp mellom 05:00–06:00",
  "badge.h1.hemSkildring": "Du vet ikke hva du leter etter — men du vil vite det når du finner det",
  "badge.h1.hemAvsloring": "Registrert en topp i soloppgangstime!",
  "badge.h2.namn": "Bursdagsklatrer",
  "badge.h2.skildring": "Registrert en topp på bursdagen din",
  "badge.h2.hemSkildring": "Noen dager er spesielle",
  "badge.h2.hemAvsloring": "Gratulerer med dagen — og med toppen!",
  "badge.h3.namn": "Hundremannen",
  "badge.h3.skildring": "100 totale registreringer",
  "badge.h3.hemSkildring": "Tiden spiller en rolle",
  "badge.h3.hemAvsloring": "100 registreringer — ekte fjellfolk!",
  "badge.h4.namn": "Syvfjellaren",
  "badge.h4.skildring": "Alle 7 fjell samme dag",
  "badge.h4.hemSkildring": "Ikke alle topper er like",
  "badge.h4.hemAvsloring": "Alle 7 fjell på én dag — en legende!",
  "badge.h5.namn": "Stamgjest",
  "badge.h5.skildring": "Samme topp 10 ganger",
  "badge.h5.hemSkildring": "Noen ting krever tålmodighet",
  "badge.h5.hemAvsloring": "Du kjenner denne toppen bedre enn noen!",

  // Lagt til automatisk — manglande nøklar funne ved gjennomgang
  "admin.avbryt": "Avbryt",
  "admin.bannerPaaSlaatt": "Redigeringsmodus på",
  "admin.flyttKnapp": "Flytt",
  "admin.fylke": "Fylke",
  "admin.kommune": "Kommune",
  "admin.leggTilKnapp": "Legg til",
  "admin.leggTilTittel": "Legg til ny topp",
  "admin.manglarNamn": "Du må skrive inn et navn",
  "badge.ingenEigarar": "Ingen har denne ennå",
  "badge.talEigarar": "{n} har denne",
  "brukar.hogaste": "Høyeste",
  "filter.autoKommune": "Automatisk kommune",
  "filter.autoKommuneSkildring": "Foreslå kommune basert på posisjonen din",
  "filter.foreslattKommune": "Er du i {kommune}?",
  "filter.ja": "Ja",
  "filter.nei": "Nei",
  "hb.andreSette": "En annen satte nettopp dette som hovedbilde",
  "hb.duFlestBesok": "Du har flest besøk ({n})",
  "hb.duLeiarTittel": "Du leder!",
  "hb.fjernKnappLabel": "Fjern hovedbilde",
  "hb.fjernKnappTekst": "Fjern",
  "hb.fjernKnappTitle": "Fjern hovedbilde",
  "hb.fjernSporsmal": "Er du sikker på at du vil fjerne dette som hovedbilde?",
  "hb.fjernTittel": "Fjern hovedbilde?",
  "hb.flestBesok": "{namn} har flest besøk ({n})",
  "hb.forsteBildeSporsmal": "Vil du sette dette som det første hovedbildet for {namn}?",
  "hb.gjeldandeLabel": "Aktive hovedbilder",
  "hb.gjeldandeSub": "Se dine gjeldende hovedbilder",
  "hb.gratulerer": "Gratulerer!",
  "hb.jaOvertaHovudbilde": "Ja, overta hovedbildet",
  "hb.jaSettHovudbilde": "Ja, sett som hovedbilde",
  "hb.leiarHint": "Ta et bedre bilde for å overta hovedbildet",
  "hb.leiartavleFane": "Ledertavle",
  "hb.leiartavleLastar": "Laster …",
  "hb.leiartavleTom": "Ingen på ledertavlen ennå",
  "hb.mineBesokFane": "Mine besøk",
  "hb.mineBesokTom": "Du har ingen besøk her ennå",
  "hb.mineHovudbileteTittel": "Mine hovedbilder",
  "hb.mineHovudbileteTom": "Du har ingen aktive hovedbilder ennå",
  "hb.neiTakk": "Nei takk",
  "hb.profilStat": "{n} toppbilder",
  "hb.seAlleTrofeer": "Se alle trofeer",
  "hb.settSuksess": "Du satte hovedbilde for {namn}!",
  "hb.sisteTurarFane": "Siste turer",
  "hb.slettSkrivHer": "Skriv «{ord}» her",
  "hb.slettSporsmal": "Er du sikker på at du vil slette besøket på {namn}?",
  "hb.slettTittel": "Slett besøk?",
  "hb.statLabel": "Toppbilder",
  "hb.statSub": "Bilder du har tatt på topper",
  "hb.tag": "Hovedbilde",
  "hb.trofeListeTittel": "{namn} sine trofeer",
  "hb.turEitt": "tur",
  "hb.turFleire": "turer",
  "hb.utfordreFeila": "Kunne ikke sette hovedbilde, prøv igjen",
  "hb.utfordreSporsmal": "Vil du utfordre og overta hovedbildet for {namn}?",
  "hending.hovudbildeTekeSub": "{topp} — noen tok et nytt hovedbilde",
  "hending.hovudbildeTekeTittel": "{namn} tok hovedbildet ditt",
  "innst.delStatistikk": "Del full statistikk",
  "innst.delStatistikkSkildring": "La andre se full statistikk på profilen din",
  "innst.katKart": "Kart",
  "innst.katLogg": "Logg",
  "innst.katPersonvern": "Personvern",
  "innst.katTest": "Test og admin",
  "innst.katUtsjaanad": "Utseende",
  "kat.hogde": "Høyde",
  "kjede.duEigDen": "Du eier den! ({n})",
  "kjede.eigd": "Eid av {namn} ({n})",
  "kjede.eyebrow": "Kjederekord",
  "kjede.ingenEnno": "Ingen kjederekorder ennå",
  "kjede.seFullListe": "Se full liste",
  "kjede.topplisteTittel": "Toppliste",
  "kjede.visPaaKart": "Vis på kart",
  "logg.rutenettInfo": "Om rutenettvisning",
  "logg.visListe": "Liste",
  "logg.visRutenett": "Rutenett",
  "loggf.tittel": "Filter",
  "profil.biletFeil": "Kunne ikke laste opp bildet, prøv igjen",
  "profil.biletVel": "Velg profilbilde",
  "reg.skrivIBoka": "Skriv i boka",
  "stat.favorittBesokt": "Besøkt {n} ganger",
  "stat.favoritttid": "Favoritt-tid",
  "stat.favoritttopp": "Favorittopp",
  "stat.kommunarBesokt": "Kommuner besøkt",
  "stat.listerFullfort": "Lister fullført",
  "stat.visMeir": "Vis mer",
  "stat.visMindre": "Vis mindre",
};

export const nn = {
  // ── Fanar / navigasjon ──────────────────────────────────────────────────
  "fane.kart": "Kart",
  "fane.toppar": "Toppar",
  "fane.logg": "Logg",
  "fane.badges": "Trofear",
  "fane.innst": "Innstillingar",

  // ── Merkevare ───────────────────────────────────────────────────────────
  "merke.tittel": "TINDRE",
  "merke.undertittel": "Fjellregistrering",
  "merke.namn": "Tindre",
  "merke.kommune": "Fjellregistrering for Bergen kommune",

  // ── Filter (kart) ───────────────────────────────────────────────────────
  "filter.tittel": "🔍 Filter",
  "filter.nullstill": "Nullstill",
  "filter.fylke": "Fylke",
  "filter.kommune": "Kommune",
  "filter.vis": "Vis",
  "filter.minHogde": "Minste høgd",
  "filter.alleToppar": "Alle toppar",
  "filter.berreUbesokte": "Berre ubesøkte",
  "filter.berreBesokte": "Berre besøkte",

  // ── Topp-panel / registrering ───────────────────────────────────────────
  "topp.aktiverGps": "📍 Aktiver GPS for å sjå avstand",
  "topp.henterPos": "Finn nøyaktig posisjon…",
  "topp.gpsNoeyaktigheit": "GPS-nøyaktigheit ±{n} m",
  "topp.forLangtBort": "Du er {n} m unna. Gå litt nærare og prøv igjen.",
  "topp.tidlegareBesokt": "✓ Tidlegare besøkt — gjentakande besøk gir nye poeng!",
  "topp.gaTilKart": "Gå til kartet, trykk på ein topp og registrer!",
  "topp.sisteTurar": "Siste turar",
  "topp.ingenTurar": "Ingen turar registrerte enno",
  "topp.ingenBilete": "Ingen bilete enno — bli den første!",
  "brukar.toppar": "toppar",
  "brukar.turar": "turar",
  "brukar.feil": "Kunne ikkje laste profilen",
  "folg.maksNaadd": "Du kan følgje maks {n} personar. Slutt å følgje nokon for å følgje fleire.",
  "folg.feil": "Klarte ikkje å oppdatere følginga. Prøv igjen.",
  "topp.visKart": "Vis på kartet",

  // ── Logg ────────────────────────────────────────────────────────────────
  "logg.unikeToppar": "Unike toppar",
  "logg.totaleTurar": "Totale turar",
  "logg.poeng": "Poeng",
  "logg.ingenBesok": "Ingen registrerte besøk enno.",
  "logg.idag": "← i dag",
  "logg.slettBilde": "Slett bildet?",

  // ── Trofé / fanfare ─────────────────────────────────────────────────────
  "trofe.nytt": "🏆 Nytt trofé!",
  "trofe.hemmelegAvslort": "✨ Hemmeleg trofé avslørt!",
  "trofe.tittel": "Trofear",
  "trofe.hemmeleg": "✨ Hemmeleg",
  "trofe.lastOpp": "Låst opp!",
  "fanfare.fullfort": "FULLFØRT!",
  "fanfare.alleToppar": "Du har bestege alle toppane!",
  "fanfare.toppPoeng": "Topp-poeng",
  "fanfare.bonus": "Bonus 🎉",

  // ── Statistikk ──────────────────────────────────────────────────────────
  "stat.tittel": "📊 Statistikk",
  "stat.forsteTur": "Første tur",
  "stat.sisteTur": "Siste tur",
  "stat.rekorddag": "Rekorddag",
  "stat.idag": "I dag",
  "stat.igar": "I går",
  "stat.dagarSidan": "{n} dagar sidan",
  "stat.toppar": "{n} toppar",
  "stat.turar": "Turar",
  "stat.hogdemeter": "Høgdemeter",
  "felles.poengSmaa": "poeng",

  // ── Vêr ─────────────────────────────────────────────────────────────────
  "ver.lastar": "🌤 Lastar vêr…",
  "ver.feil": "Kunne ikkje hente vêr",
  "ver.imorgon": "i morgon",
  "ver.klart": "Klårt",
  "ver.lettskya": "Lettskya",
  "ver.overskya": "Overskya",
  "ver.take": "Tåke",
  "ver.yr": "Yr",
  "ver.regn": "Regn",
  "ver.sno": "Snø",
  "ver.regnbyer": "Regnbyer",
  "ver.snobyer": "Snøbyer",
  "ver.torden": "Tordenvêr",
  "ver.perPunktAv": "Vêr per punkt er skrudd av i innstillingar",

  // ── Kart ────────────────────────────────────────────────────────────────
  "kart.lastar": "Lastar kart…",
  "kart.resetNord": "Reset nord",
  "kart.sokStadnamn": "Søk på stadnamn…",
  "kart.sokjer": "Søkjer…",
  "kart.toppbilde": "Toppbilde",

  // ── Admin (rediger topp) ────────────────────────────────────────────────
  "admin.rediger": "✏️ Admin — Rediger topp",
  "admin.namn": "Namn",
  "admin.hogde": "Høgde (m.o.h.)",
  "admin.lister": "Lister",
  "admin.trykkFlytt": "← Trykk på kartet for å flytte",
  "admin.modus": "Admin-modus ✏️",
  "admin.modusSkildring": "Rediger og flytt toppar direkte i kartet",
  "admin.lastNed": "⬇ Last ned peaks.js",
  "admin.nullstill": "Nullstill endringar",
  "admin.nullstillSporsmal": "Nullstill admin-endringar?",
  "admin.endra": "✏ Endra — autolagra",

  // ── Innlogging / tilgang ────────────────────────────────────────────────
  "inn.tittel": "Tindre",
  "inn.skrivKode": "Skriv inn tilgangskode",
  "inn.kodePrompt": "Skriv inn tilgangskoden din",
  "inn.kodeInfo": "Du har motteke ein kode på e-post. Skriv den inn for å kome inn.",
  "inn.kodePlassholdar": "T.d. FJELL-1234",
  "inn.harIkkjeKode": "Har du ikkje kode? Be om tilgang",
  "inn.soknadSendt": "Søknad sendt!",
  "inn.soknadInfo": "Du vil motta ein tilgangskode på e-post innan kort tid.",
  "inn.tilbakeKode": "← Tilbake til kode-innlogging",
  "inn.beOmTilgang": "Be om tilgang",
  "inn.epostInfo": "Skriv inn e-postadressa di. Du vil motta ein kode på e-post.",
  "inn.epostPlassholdar": "din@epost.no",

  // ── Innstillingar ───────────────────────────────────────────────────────
  "innst.tittel": "Innstillingar",
  "innst.fullskjerm": "Fullskjerm kart",
  "innst.fullskjermAv": "Slå av for å gå tilbake til normal visning",
  "innst.fullskjermSkildring": "Heile skjermen til kart — flytande kontroller",
  "innst.morktTema": "Mørkt tema",
  "innst.morktSkildring": "Bytt mellom mørkt og lyst utsjånad",
  "innst.testmodus": "Testmodus",
  "innst.testSkildring": "Registrer toppar utan å vere på staden",
  "innst.testFanfare": "🏆 Test fanfare",
  "innst.verPunkt": "Vêr ved kartpunkt",
  "innst.verPunktSkildring": "Vis vêrvarsel når du trykkar på kartet",
  "innst.filterLogg": "Filter i logg",
  "innst.filterLoggSkildring": "Filtrer loggen på periode, liste og bilde",
  "innst.visHogde": "Vis høgde (moh)",
  "innst.visHogdeSkildring": "Vis di høgde over havet på kartet",
  "innst.visMalestokk": "Vis målestokk",
  "innst.visMalestokkSkildring": "Vis avstandsskala på kartet",
  "innst.skjulUtanBilde": "Skjul besøk utan bilete",
  "innst.skjulUtanBildeSkildring": "Vis berre turar med bilete på topp-profilen",
  "innst.kompakt": "Kompakt visning",
  "innst.kompaktSkildring": "Skjul progress-boksane, berre ikon i nav",
  "innst.listeLayout": "Listelayout",
  "innst.listeLayoutNytt": "Nytt (med bilete)",
  "innst.listeLayoutGammalt": "Klassisk",
  "innst.loggKort": "Loggkort",
  "innst.loggKortNytt": "Nytt",
  "innst.loggKortGammalt": "Klassisk",
  "innst.regStil": "Registreringsstil",
  "innst.regStilSkriv": "Skriv inn",
  "innst.regStilSkyv": "Skyv for å registrere",
  "innst.fargetema": "Fargetema",
  "innst.fargetemaSkildring": "Vel aksentfarge for appen",
  "innst.bursdag": "🎂 Bursdag",
  "innst.bursdagSkildring": "Kanskje skjer det noko spesielt på dagen din…",
  "innst.kartdata": "Kartdata",
  "innst.landingsside": "Tindre — Landingsside",
  "innst.landingsSkildring": "Info om appen",
  "innst.loggUt": "Logg ut",
  "innst.loggUtSporsmal": "Logg ut? Du treng koden din for å kome inn igjen.",
  "innst.nullstillData": "Nullstill all data",
  "innst.nullstillDataSporsmal": "Nullstill ALL registreringsdata? Dette kan ikkje angrast.",
  "innst.sprak": "Språk",
  "innst.sprakSkildring": "Vel språk for appen",

  // ── Språk-namn ──────────────────────────────────────────────────────────
  "sprak.nb": "Bokmål",
  "sprak.nn": "Nynorsk",

  // ── Fargetema-namn ──────────────────────────────────────────────────────
  "tema.oransje": "Oransje",
  "tema.bla": "Kongeblå",

  // ── Logg-filter ─────────────────────────────────────────────────────────
  "loggf.alle": "Alle",
  "loggf.veke": "Denne veka",
  "loggf.mnd": "Denne månaden",
  "loggf.aar": "I år",
  "loggf.alleLister": "Alle lister",
  "loggf.medBilde": "Med bilde",
  "loggf.utanBilde": "Utan bilde",

  // ── Trofé-kategoriar ────────────────────────────────────────────────────
  "kat.topper": "Toppar & Lister",
  "kat.lister": "Listemeistrar",
  "kat.streak": "Streaks",
  "kat.tid": "Tid & Sesong",
  "kat.spesial": "Spesial ⭐",

  // ── Lagring ─────────────────────────────────────────────────────────────
  "lagring.full": "⚠ Lagringa er full — siste endring kunne ikkje lagrast. Slett nokre bilete i loggen.",

  // ── Diverse ─────────────────────────────────────────────────────────────
  "map.avsluttFullskjerm": "Avslutt fullskjerm",
  "map.fullskjerm": "Fullskjerm",
  "ver.hentarHogde": "Hentar høgde…",
  "ver.ukjendHogde": "Ukjend høgde",
  "ver.dettePunktet": "dette punktet",
  "inn.gaaTilApp": "Gå til appen →",
  "inn.sjekkar": "⟳ Sjekkar…",
  "inn.sender": "⟳ Sender…",
  "inn.sendForespurnad": "Send førespurnad →",
  "inn.epostEmne": "Ny Tindre-førespurnad om tilgang",
  "inn.ventS": "🔒 Vent {s}s",
  "stat.aktiveDagar": "Aktive dagar",
  "stat.hogasteTopp": "Høgaste topp",
  "stat.totalHogdemeter": "Total høgdemeter",
  "stat.dagar": "{n} dagar",
  "innst.testPaa": "🧪 Testmodus PÅ — du kan registrere utan GPS",
  "innst.testAv": "Testmodus AV",
  "kat.hemmelege": "Hemmelege 🔒",

  // ── Innlogging (Supabase) ───────────────────────────────────────────────
  "auth.loggInnTittel": "Logg inn",
  "auth.registrerTittel": "Lag konto",
  "auth.epost": "E-post",
  "auth.passord": "Passord",
  "auth.visingsnamn": "Visingsnamn",
  "auth.epostPlassh": "din@epost.no",
  "auth.passordPlassh": "Minst 6 teikn",
  "auth.namnPlassh": "Det andre ser deg som",
  "auth.loggInnKnapp": "Logg inn",
  "auth.registrerKnapp": "Lag konto",
  "auth.loggerInn": "⟳ Loggar inn…",
  "auth.registrerer": "⟳ Lagar konto…",
  "auth.byttTilRegistrer": "Ny her? Lag konto",
  "auth.byttTilInnlogging": "Har du konto? Logg inn",
  "auth.feilInnlogging": "Feil e-post eller passord",
  "auth.feilEpostFinst": "E-posten er allereie registrert",
  "auth.feilPassordKort": "Passordet må vere minst 6 teikn",
  "auth.invkodePlassh": "Invitasjonskode",
  "auth.feilInvkode": "Ugyldig invitasjonskode",
  "auth.feilNamnManglar": "Skriv eit visingsnamn",
  "auth.feilEpostUgyldig": "Skriv ei gyldig e-postadresse",
  "auth.feilGenerell": "Noko gjekk gale. Prøv igjen.",
  "auth.feilBackend": "Får ikkje kontakt med tenaren. Prøv igjen seinare.",
  "auth.loggUt": "Logg ut",
  "auth.loggUtSporsmal": "Logg ut?",

  // ── Utforskande modus (utan konto) ──────────────────────────────────────
  "utforsk.loggInn": "Logg inn",
  "utforsk.registrerKrev": "Logg inn for å registrere",
  "utforsk.loggKrev": "Logg inn for å sjå loggen din og samle toppar.",
  "utforsk.trofeKrev": "Logg inn for å låse opp og samle trofear.",
  "utforsk.loggInnKnapp": "Logg inn / lag konto",

  // ── Bilde ────────────────────────────────────────────────────────────────
  "bilde.berreBilete": "Berre bilete er tillate (JPG, PNG, HEIC).",
  "bilde.feilLes": "Klarte ikkje å lese biletet. Prøv eit anna.",
  "bilde.forStort": "Biletet er for stort. Vel eit mindre.",
  "bilde.tittel": "Legg til bilete",
  "bilde.dokumenter": "{namn} — dokumenter toppbesøket",
  "bilde.taBilde": "Ta bilete",
  "bilde.velBibliotek": "Vel frå bibliotek",

  // ── Profil ──────────────────────────────────────────────────────────────
  "test.kodePrompt": "Skriv testkode:",
  "test.opna": "Testmodus låst opp 🧪",
  "test.laas": "Lås testmodus",
  "profil.tittel": "Profil",
  "profil.rediger": "Rediger",
  "profil.namn": "Visingsnamn",
  "profil.bosted": "Bustad",
  "profil.bostedPlassh": "T.d. Bergen",
  "profil.bursdag": "Bursdag",
  "profil.dag": "Dag",
  "profil.maaned": "Månad",
  "profil.epost": "E-post",
  "profil.synlegAndre": "Synleg for andre seinare",
  "profil.berreDu": "Berre du ser dette",
  "profil.fyllUt": "Trykk for å fylle ut profilen",
  "profil.lagra": "Lagre",
  "profil.lagrar": "Lagrar…",
  "profil.feilNamn": "Du må ha eit visingsnamn",
  "profil.feilLagra": "Klarte ikkje lagre. Sjekk nettet og prøv igjen.",

  // ── Dagsturhytter + kart-filter ─────────────────────────────────────────
  "hytte.merkelapp": "Dagsturhytte",
  "hytte.framme": "Du er ved hytta!",
  "topp.framme": "Du er på toppen!",
  "innst.punktFilter": "Vis på kartet",
  "innst.punktFilterSkildring": "Vel om kartet viser toppar, hytter eller begge.",
  "punkt.begge": "Begge",
  "punkt.toppar": "Toppar",
  "punkt.hytter": "Hytter",

  // ── Gløymt passord (kode-basert recovery) ───────────────────────────────
  "auth.glemtLenke": "Gløymt passordet?",
  "auth.glemtTittel": "Tilbakestill passord",
  "auth.glemtEpostInfo": "Skriv e-posten din, så sender vi ein kode du kan bruke til å velje nytt passord.",
  "auth.sendKode": "Send kode",
  "auth.sender": "⟳ Sender…",
  "auth.kodeSendtTittel": "Sjekk e-posten din",
  "auth.kodeInfo": "Har du ein konto hos oss, har vi sendt ein kode til e-posten. Skriv han inn og vel eit nytt passord.",
  "auth.kode": "Kode",
  "auth.kodePlassh": "Kode frå e-posten",
  "auth.nyttPassord": "Nytt passord",
  "auth.settPassord": "Sett nytt passord",
  "auth.oppdaterer": "⟳ Oppdaterer…",
  "auth.feilKode": "Feil eller utgått kode",
  "auth.tilbakeInnlogging": "← Tilbake til innlogging",
  "auth.passordOppdatert": "Passordet er oppdatert.",

  // ── Troféar (badges) ────────────────────────────────────────────────────
  "badge.b10.namn": "Klatrar",
  "badge.b10.skildring": "Besøkt 10 unike toppar",
  "badge.b25.namn": "Fjellven",
  "badge.b25.skildring": "Besøkt 25 unike toppar",
  "badge.b50.namn": "Toppjeger",
  "badge.b50.skildring": "Besøkt 50 unike toppar",
  "badge.ball.namn": "Bergensmester",
  "badge.ball.skildring": "Alle toppar i Bergen fullført",
  "badge.t10.namn": "Topp 10",
  "badge.t10.skildring": "Fullført Topp 10-lista",
  "badge.t20.namn": "Topp 20",
  "badge.t20.skildring": "Fullført Topp 20-lista",
  "badge.t50.namn": "Topp 50",
  "badge.t50.skildring": "Fullført Topp 50-lista",
  "badge.t100.namn": "Topp 100",
  "badge.t100.skildring": "Fullført Topp 100-lista",
  "badge.dobbel.namn": "Dobbelen",
  "badge.dobbel.skildring": "2 toppar same dag",
  "badge.trippel.namn": "Trippelen",
  "badge.trippel.skildring": "3 toppar same dag",
  "badge.femmar.namn": "Femmaren",
  "badge.femmar.skildring": "5 toppar same dag",
  "badge.tidleg.namn": "Morgonfugl",
  "badge.tidleg.skildring": "Registrert ein topp før kl. 07:00",
  "badge.natt.namn": "Nattugla",
  "badge.natt.skildring": "Registrert ein topp etter kl. 21:00",
  "badge.vinter.namn": "Vinterfjell",
  "badge.vinter.skildring": "Topp i desember",
  "badge.nyttaar.namn": "Nyttårsklatrar",
  "badge.nyttaar.skildring": "Topp 1. januar",
  "badge.syttande.namn": "17. mai-klatrar",
  "badge.syttande.skildring": "Registrert ein topp på nasjonaldagen",
  "badge.baal.namn": "Jonsokbål",
  "badge.baal.skildring": "Besøkt Gullfjellet etter kl. 18:00 på sankthans (23. juni)",
  "badge.sju.namn": "7-fjellsturen",
  "badge.sju.skildring": "Alle 7 fjell i rett rekkefølge same dag",
  "badge.h1.namn": "Soloppgang",
  "badge.h1.skildring": "Registrert ein topp mellom 05:00–06:00",
  "badge.h1.hemSkildring": "Du veit ikkje kva du leitar etter — men du vil vite det når du finn det",
  "badge.h1.hemAvsloring": "Registrert ein topp i soloppgangstime!",
  "badge.h2.namn": "Bursdagsklatrar",
  "badge.h2.skildring": "Registrert ein topp på bursdagen din",
  "badge.h2.hemSkildring": "Nokon dagar er spesielle",
  "badge.h2.hemAvsloring": "Gratulerer med dagen — og med toppen!",
  "badge.h3.namn": "Hundremannen",
  "badge.h3.skildring": "100 totale registreringar",
  "badge.h3.hemSkildring": "Tida speler ei rolle",
  "badge.h3.hemAvsloring": "100 registreringar — ekte fjellfolk!",
  "badge.h4.namn": "Sjufjellaren",
  "badge.h4.skildring": "Alle 7 fjell same dag",
  "badge.h4.hemSkildring": "Ikkje alle toppar er like",
  "badge.h4.hemAvsloring": "Alle 7 fjell på éin dag — ein legende!",
  "badge.h5.namn": "Stamgjest",
  "badge.h5.skildring": "Same topp 10 gonger",
  "badge.h5.hemSkildring": "Nokre ting krev tolmod",
  "badge.h5.hemAvsloring": "Du kjenner denne toppen betre enn nokon!",

  // Lagt til automatisk — manglande nøklar funne ved gjennomgang
  "admin.avbryt": "Avbryt",
  "admin.bannerPaaSlaatt": "Redigeringsmodus på",
  "admin.flyttKnapp": "Flytt",
  "admin.fylke": "Fylke",
  "admin.kommune": "Kommune",
  "admin.leggTilKnapp": "Legg til",
  "admin.leggTilTittel": "Legg til ny topp",
  "admin.manglarNamn": "Du må skrive inn eit namn",
  "badge.ingenEigarar": "Ingen har denne enno",
  "badge.talEigarar": "{n} har denne",
  "brukar.hogaste": "Høgaste",
  "filter.autoKommune": "Automatisk kommune",
  "filter.autoKommuneSkildring": "Føreslå kommune basert på posisjonen din",
  "filter.foreslattKommune": "Er du i {kommune}?",
  "filter.ja": "Ja",
  "filter.nei": "Nei",
  "hb.andreSette": "Ein annan sette nettopp dette som hovudbilete",
  "hb.duFlestBesok": "Du har flest besøk ({n})",
  "hb.duLeiarTittel": "Du leier!",
  "hb.fjernKnappLabel": "Fjern hovudbilete",
  "hb.fjernKnappTekst": "Fjern",
  "hb.fjernKnappTitle": "Fjern hovudbilete",
  "hb.fjernSporsmal": "Er du sikker på at du vil fjerne dette som hovudbilete?",
  "hb.fjernTittel": "Fjern hovudbilete?",
  "hb.flestBesok": "{namn} har flest besøk ({n})",
  "hb.forsteBildeSporsmal": "Vil du setje dette som det første hovudbiletet for {namn}?",
  "hb.gjeldandeLabel": "Aktive hovudbilete",
  "hb.gjeldandeSub": "Sjå dine gjeldande hovudbilete",
  "hb.gratulerer": "Gratulerer!",
  "hb.jaOvertaHovudbilde": "Ja, overta hovudbiletet",
  "hb.jaSettHovudbilde": "Ja, set som hovudbilete",
  "hb.leiarHint": "Ta eit betre bilete for å overta hovudbiletet",
  "hb.leiartavleFane": "Leiartavle",
  "hb.leiartavleLastar": "Lastar …",
  "hb.leiartavleTom": "Ingen på leiartavla enno",
  "hb.mineBesokFane": "Mine besøk",
  "hb.mineBesokTom": "Du har ingen besøk her enno",
  "hb.mineHovudbileteTittel": "Mine hovudbilete",
  "hb.mineHovudbileteTom": "Du har ingen aktive hovudbilete enno",
  "hb.neiTakk": "Nei takk",
  "hb.profilStat": "{n} toppbilete",
  "hb.seAlleTrofeer": "Sjå alle troféar",
  "hb.settSuksess": "Du sette hovudbilete for {namn}!",
  "hb.sisteTurarFane": "Siste turar",
  "hb.slettSkrivHer": "Skriv «{ord}» her",
  "hb.slettSporsmal": "Er du sikker på at du vil slette besøket på {namn}?",
  "hb.slettTittel": "Slett besøk?",
  "hb.statLabel": "Toppbilete",
  "hb.statSub": "Bilete du har teke på toppar",
  "hb.tag": "Hovudbilete",
  "hb.trofeListeTittel": "{namn} sine troféar",
  "hb.turEitt": "tur",
  "hb.turFleire": "turar",
  "hb.utfordreFeila": "Kunne ikkje setje hovudbilete, prøv igjen",
  "hb.utfordreSporsmal": "Vil du utfordre og overta hovudbiletet for {namn}?",
  "hending.hovudbildeTekeSub": "{topp} — nokon tok eit nytt hovudbilete",
  "hending.hovudbildeTekeTittel": "{namn} tok hovudbiletet ditt",
  "innst.delStatistikk": "Del full statistikk",
  "innst.delStatistikkSkildring": "La andre sjå full statistikk på profilen din",
  "innst.katKart": "Kart",
  "innst.katLogg": "Logg",
  "innst.katPersonvern": "Personvern",
  "innst.katTest": "Test og admin",
  "innst.katUtsjaanad": "Utsjånad",
  "kat.hogde": "Høgde",
  "kjede.duEigDen": "Du eig han! ({n})",
  "kjede.eigd": "Eigd av {namn} ({n})",
  "kjede.eyebrow": "Kjederekord",
  "kjede.ingenEnno": "Ingen kjederekordar enno",
  "kjede.seFullListe": "Sjå full liste",
  "kjede.topplisteTittel": "Toppliste",
  "kjede.visPaaKart": "Vis på kart",
  "logg.rutenettInfo": "Om rutenettvising",
  "logg.visListe": "Liste",
  "logg.visRutenett": "Rutenett",
  "loggf.tittel": "Filter",
  "profil.biletFeil": "Kunne ikkje laste opp biletet, prøv igjen",
  "profil.biletVel": "Vel profilbilete",
  "reg.skrivIBoka": "Skriv i boka",
  "stat.favorittBesokt": "Vitja {n} gonger",
  "stat.favoritttid": "Favoritt-tid",
  "stat.favoritttopp": "Favorittopp",
  "stat.kommunarBesokt": "Kommunar vitja",
  "stat.listerFullfort": "Lister fullførte",
  "stat.visMeir": "Vis meir",
  "stat.visMindre": "Vis mindre",
};

// Hjelpefunksjon: returner ordbok for valt språk (fallback nb)
export function ordbokFor(kode) {
  return kode === "nn" ? nn : nb;
}
